import { DropdownOption } from "../components/common/Dropdown";

const SEARCH_SESSION_KEY = "ubt-shared-search";

export interface SharedSearchData {
  // Common fields for Select UBT and Search Projects
  selectedRegionCode?: DropdownOption;
  selectedEntityCode?: DropdownOption;
  selectedAreaCode?: DropdownOption;
  selectedCenterCode?: DropdownOption;
  selectedLocationCode?: DropdownOption;
  sortByCostCenter?: string;
  selectedCostCenterCode?: {
    isAllSelected: boolean;
    selectedIds: (string | number)[];
  };
  selectedSearchBy?: DropdownOption;
  selectedSearchByText?: string;
  selectedFromId?: string;
  selectedToId?: string;
  selectedProjectName?: string;

  // Search Projects specific fields
  selectedRating?: { isAllSelected: boolean; selectedIds: (string | number)[] };
  selectedValueCompass?: {
    isAllSelected: boolean;
    selectedIds: (string | number)[];
  };
  selectedMetrix?: { isAllSelected: boolean; selectedIds: (string | number)[] };
  selectedResults?: {
    isAllSelected: boolean;
    selectedIds: (string | number)[];
  };
  selectedTestOfChangeRating?: {
    isAllSelected: boolean;
    selectedIds: (string | number)[];
  };
  selectedProjectType?: string;

  // Teams Reporting specific fields (simpler array structure, no isAllSelected)
  selectedRoles?: (string | number)[];
  teamsReportingRating?: (string | number)[]; // Different from selectedRating above
  startDate?: string;
  endDate?: string;
  selectedLeadNuid?: string;
  leadMemberName?: string;
  searchAllLeadRoles?: boolean;

  timestamp?: number;
}

/**
 * Save search filter data to sessionStorage
 */
export const saveSearchToSession = (data: SharedSearchData): void => {
  try {
    const searchData: SharedSearchData = {
      ...data,
      timestamp: Date.now(),
    };
    sessionStorage.setItem(SEARCH_SESSION_KEY, JSON.stringify(searchData));
  } catch (error) {
    console.error("Failed to save search data to sessionStorage:", error);
  }
};

/**
 * Load search filter data from sessionStorage
 */
export const loadSearchFromSession = (): SharedSearchData | null => {
  try {
    const stored = sessionStorage.getItem(SEARCH_SESSION_KEY);
    if (!stored) {
      return null;
    }

    const data: SharedSearchData = JSON.parse(stored);

    // Validate the data structure
    if (!data || typeof data !== "object") {
      return null;
    }

    return data;
  } catch (error) {
    console.error("Failed to load search data from sessionStorage:", error);
    return null;
  }
};

/**
 * Clear search filter data from sessionStorage
 */
export const clearSearchFromSession = (): void => {
  try {
    sessionStorage.removeItem(SEARCH_SESSION_KEY);
  } catch (error) {
    console.error("Failed to clear search data from sessionStorage:", error);
  }
};

/**
 * Check if sessionStorage has saved search data
 */
export const hasStoredSearch = (): boolean => {
  try {
    return sessionStorage.getItem(SEARCH_SESSION_KEY) !== null;
  } catch (error) {
    console.error("Failed to check sessionStorage:", error);
    return false;
  }
};
